<template>
    <div class="ppv2-ml-5 ppv2-mb-3 ppv2-mt-8">
        <label class="form-label font_label"> Couleur bloc {{ (has_shap_1 == 1 ? 1 : '') + (has_shap_2 == 1 ? 2 : '') }} </label>
        <div class="long_bloc_color">
            <div v-for="(color, index2) in colors" :key="index2" class="pos_bloc_1">
                <div class="bloc_btn_text">
                    <button
                        :id="
                            color.parameter +
                            index +
                            (has_shap_1 == 1 ? '_has_shap_1' : '') +
                            (has_shap_2 == 1 ? '_has_shap_2' : '')
                        "
                        @click="setting_color(index, color.value, $event)"
                        type="button"
                        class="long_bloc_color0"
                        :style="{
                            backgroundColor: color.value,
                        }"
                    ></button>
                    <span>Palette {{ index2 + 1 }}</span>
                </div>
            </div>
            <div class="pos_bloc_1">
                <div class="bloc_btn_text">
                    <div style="position: relative; display: inline-block; width: 50px; height: 50px">
                        <input
                            ref="colorInputs"
                            @input="setting_color(index, $event.target.value, $event)"
                            :id="
                                'selected_btn_' +
                                index +
                                (has_shap_1 == 1 ? '_has_shap_1' : '') +
                                (has_shap_2 == 1 ? '_has_shap_2' : '')
                            "
                            type="color"
                            class="long_bloc_color0"
                            style="background-color: #7d2dbd"
                        />

                        <i
                            class="fas fa-edit edit-icon"
                            @click="triggerColorInput(index)"
                            style="
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                font-size: 16px;
                                background-color: #000;
                                color: #fff;
                                border-radius: 50%;
                                padding: 6px;
                                z-index: 1;
                                cursor: pointer;
                                background-color: transparent;
                            "
                        ></i>
                    </div>
                    <span>Autre</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['index', 'info_page', 'has_shap_1', 'has_shap_2', 'colors'],
    data() {
        return {}
    },
    methods: {
        setting_color(index, color, $event) {
            let type = ''
            let id = $event.currentTarget.id
            console.log(id)
            if (id.indexOf('_has_shap_1') !== -1) {
                type = 'has_shap_1'
            } else {
                type = 'has_shap_2'
            }
            this.removeStyleBtn(type, index)
            document.querySelector('#' + id).style.boxShadow = '0px 5px 10px -4px ' + color
            this.$emit('color-uploaded', { index: index, type: type, color: color })
        },
        removeStyleBtn(type, index) {
            document.querySelector('#primary_color' + index + '_' + type).style.boxShadow = ''
            document.querySelector('#secondary_color' + index + '_' + type).style.boxShadow = ''
            document.querySelector('#menus_color' + index + '_' + type).style.boxShadow = ''
        },
        triggerColorInput(index) {
            // get the list of color inputs
            const inputs = this.$refs.colorInputs
            // if using v-for and refs on multiple elements, it's an array
            if (Array.isArray(inputs) && inputs[index]) {
                inputs[index].click()
            } else if (inputs) {
                // single input
                inputs.click()
            }
        },
    },
}
</script>
<style scoped>
.pos_bloc_1 {
    width: 100%;
    height: 106px;
    top: 946px;
    left: 24px;
    gap: 45px;
    display: flex;
}
.long_bloc_color {
    width: 100%;
    display: inline-flex;
    top: 0px;
    position: relative;
    gap: 15px;
}
.font_label {
    font-family: Poppins Medium;
    font-size: 18px;
    line-height: 140%;
    letter-spacing: 0%;
    text-transform: unset;
}
.long_bloc_color0 {
    width: 50px;
    height: 50px;
    border-radius: 30px;
}
.bloc_btn_text {
    display: inline-grid;
}
.ml-5 {
    margin-left: 25px;
}
</style>
